import { formatUIDate, formatUIDateTime } from 'utils/helpers'

export const columns = [
  {
    title: 'Status',
    field: 'supportStatus',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'HUBC',
    field: 'hubName',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '100px'
  },
  {
    title: 'Cod support',
    field: 'externalCode',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Cod eterogen',
    field: 'heterogeneousCode',
    align: 'left',
    type: 'string',
    width: '250px'
  },
  {
    title: 'Creat de',
    field: 'createdBy',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Data crearii',
    field: 'created',
    align: 'left',
    type: 'string',
    render: row => formatUIDateTime(row.created),
    width: '100px'
  },
  {
    title: 'Actualizat de',
    field: 'updatedBy',
    align: 'left',
    type: 'string',
    width: '100px'
  },
  {
    title: 'Ultima actualizare',
    field: 'updated',
    align: 'left',
    type: 'string',
    render: row => formatUIDateTime(row.updated),
    width: '100px'
  }
]
